export class CustomerLastOrders {
    orderNum: string;
    orderDate: string;
    restaurant: string;
    total: string;
    status: string;
    receipt: string;
    clientId: string;
    allowReorder:boolean; //This is not saved on the database. It's generated whenever you get the orders from the database...
    cart: any

    constructor(orderNum: string, orderDate: string, restaurant: string, total: string, status: string, receipt: string, clientId: string, allowReorder:boolean, cart: any) {
        this.orderNum = orderNum;
        this.orderDate = orderDate;
        this.restaurant = restaurant;
        this.total = total;
        this.status = status;
        this.receipt = receipt;
        this.clientId = clientId;
        this.allowReorder = allowReorder;
        this.cart = cart;
    }

    static newFromAws(awsData: any):CustomerLastOrders {
        return new CustomerLastOrders(
            awsData.orderNumber,
            awsData.timeOrderWasPlacedStr,
            awsData.restaurantName,
            awsData.cart.total,
            awsData.orderStatus,
            awsData.paper_receipt,
            awsData.clientId,
            awsData.allowReorder,
            awsData.cart
        )
    }
}